<script setup>
import useSharedData from "@/use/SharedData.js";
import {defineEmits, defineProps, ref, watch} from "vue";
import axios from "axios";
import {useCountryCityStore} from "@/stores/CountryCity";

const props = defineProps({
    value: [Number, String],
    readonly: Boolean,
    label: String,
    rules: Array,
    itemValue: String,
    stateId: Number,
});

const emit = defineEmits(['input']);

const {loading, inputColor, inputBackgroundColor} = useSharedData();

const countryCityStore = useCountryCityStore();

const city = ref(null);
const cities = ref([]);

function findAll() {
    loading.value = true;
    axios.get(`/countryCities/state/${props.stateId}`).then(response => {
        countryCityStore.setCountryCities(response.data);
        cities.value = response.data;
    }).finally(() => {
        loading.value = false;
    });
}

function input(value) {
    emit('input', value);
}

watch(() => props.stateId, () => {
    if (props.stateId) {
        findAll();
    }
}, {immediate: true});

watch(() => props.value, () => {
    city.value = props.value;
}, {immediate: true});
</script>

<template>
    <div>
        <v-autocomplete
            v-model="city"
            :items="cities"
            :item-value="itemValue"
            item-text="name"
            :label="label"
            outlined
            dense
            :color="inputColor"
            :background-color="inputBackgroundColor"
            :loading="loading"
            :readonly="readonly"
            :clearable="!readonly"
            :rules="rules"
            hide-details="auto"
            @input="input"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>